module.exports = __webpack_public_path__ + "static/media/yes_img1.5d3ead34.png";